import { IFsMap } from '../types';

export abstract class FsMapPanoramasServiceProvider<TMap extends IFsMap> {
  abstract readonly id: string;
  abstract readonly geospatialProvider: string;

  abstract onMapLoaded(map: TMap): void;
  abstract addToMap(): void;
  abstract removeFromMap(): void;
}
